import React, { useState, useRef, useEffect } from 'react';
import Toast from '../../Toast/Toast';
import AWS from 'aws-sdk';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import config from '../../../../../../config/config';
import { useKeysStore } from '../../../../../../../core/store/useKeysStore';

const FileUploadS3 = (props) => {
  const {keys} = useKeysStore();
  const [value, setValue] = useState('');
  const [file, setFile] = useState(props.file ? props.file : '');
  const [fileExtension, setFileExtension] = useState(
    props.file ? props.file.split('.').pop() : ''
  );
  const [isImage, setIsImage] = useState(
    props.file
      ? ['jpeg', 'jpg', 'png'].includes(props.file.split('.').pop().toLowerCase())
      : false
  );
  const [fileKey, setFileKey] = useState('');
  const [link, setLink] = useState(props.file);

  const extensionImages = ['jpeg', 'jpg', 'png'];

  const limitSize = props.limitFileSize ? props.limitFileSize : 10;

  const uploadRef = useRef(null);

  AWS.config.update({
    accessKeyId: keys?.bucketS3?.accessKeyId,
    secretAccessKey: keys?.bucketS3?.secretAccessKey,
    region: keys?.bucketS3?.region,
  });

  useEffect(() => {
    if (uploadRef.current) {
      const progress = Math.round((uploadRef.current.bytesUploaded / uploadRef.current.contentLength) * 100);
      setUploadProgress(progress);
    }
  }, []);

  const [showProgress, setShowProgress] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadCancelled, setUploadCancelled] = useState(false);
  const [showAttachButton, setShowAttachButton] = useState(false);

  const handleChange = (event) => {
    if (props.disabled) {
      Toast.error(`Upload de arquivo desabilitado.`);
      return;
    } else if (event.target.files.length > 0) {
      const size = event.target.files[0].size / (1024 * 1024);
      if (size > limitSize) {
        Toast.error(`O arquivo não pode ser maior que ${limitSize} MB(s).`);
        return;
      }

      const s3 = new AWS.S3();

      const currentDate = moment().format('YYYY/MM/DD');
      const fileName = event.target.files[0].name;
      const fileExtension = fileName.split('.').pop();
      const isImage = extensionImages.includes(fileExtension.toLowerCase());

      const uniqueId = uuidv4();

      let fileUrl = `${props.path}/uploads/${currentDate}/${uniqueId}.${fileExtension}`;

      if (keys?.bucketS3 && keys?.bucketS3?.path_default && keys?.bucketS3?.path_default != '') {
        fileUrl = `${keys?.bucketS3?.path_default}/${props.path}/uploads/${currentDate}/${uniqueId}.${fileExtension}`;
      } else {
        Toast.error('Erro ao fazer o upload do arquivo. É necessário informar o path_default nas configurações.');
        return;
      }

      fileUrl = fileUrl.replace('//', '/');

      setFileKey(fileUrl)

      const params = {
        Bucket: keys?.bucketS3?.bucket,
        Key: fileUrl,
        Body: event.target.files[0],
      };

      beforeUpload();
      const s3Upload = s3.upload(params);

      s3Upload.on('httpUploadProgress', (progress) => {
        const uploadProgress = Math.round((progress.loaded / progress.total) * 100);
        setUploadProgress(uploadProgress);
      });

      s3Upload.send((err, data) => {
        if (err) {
          Toast.error('Erro ao fazer o upload do arquivo.');
        } else {
          onUpload(props.name, data.Location);
          setValue('');
          setFile(fileName);
          setFileExtension(fileExtension);
          setIsImage(isImage);
          setLink(fileUrl);
        }
        setShowProgress(false);
      });

      setUploadProgress(0);
      setUploadCancelled(false);
      setShowProgress(true);
      uploadRef.current = s3Upload;
    }
  };

  const onUpload = (inputName, file) => {
    props.onUpload(inputName, file);
  };

  const beforeUpload = () => {
    props.beforeUpload();
  };

  const deleteFile = () => {
    const s3 = new AWS.S3();

    const params = {
      Bucket: keys?.bucketS3?.bucket,
      Key: link
    };

    s3.deleteObject(params, (error, data) => {
      if (error) {
        Toast.error('Erro ao excluir o arquivo.');
      } else {
        setShowAttachButton(false);
        setLink('');
        setFile('');
        setShowProgress(false);
        props.onRemove(props.name, '');
      }
    });
  };



  const clickRemove = () => {
    deleteFile();
  };

  const cancelUpload = () => {
    if (uploadRef.current) {
      uploadRef.current.abort();
      setUploadCancelled(true);
      setShowProgress(false);
      setShowAttachButton(false);
      setLink('');
    }
  };

  return (
    <div style={{ marginTop: 10 }}>
      {!file && !props.disabled && (
        <div>
          <label className="btn btn-primary">
            <input
              id="my-file-selector"
              className="d-none"
              type="file"
              name={props.name}
              onChange={handleChange}
              accept={props.accept}
              value={value}
              autoFocus={props.autoFocus ? true : false}
            />
            {props.titleButton}
          </label>
          {props.error && (
            <div
              className="error invalid-feedback"
              style={{ display: 'inline', width: '100%', marginLeft: '10px' }}
            >
              {props.error}
            </div>
          )}
        </div>
      )}

      {showProgress && (
        <div>
          <div>
            <progress value={uploadProgress} max="100" />
          </div>
          {!uploadCancelled && (
            <div>
              <button onClick={cancelUpload}>Cancelar</button>
            </div>
          )}
        </div>
      )}
      {file && !isImage && (
        <div>
          <a target="_blank" href={props.file} rel="noreferrer">
            Download
          </a>
          &nbsp;&nbsp;
          <span onClick={clickRemove} className="required" style={{ cursor: 'pointer' }}>
            <strong>X</strong>
          </span>
          {props.error && (
            <div
              className="error invalid-feedback"
              style={{ display: 'inline', width: '100%', marginLeft: '10px' }}
            >
              {props.error}
            </div>
          )}
        </div>
      )}
      {file && isImage && (
        <div style={{ width: '100px' }}>
          <a target="_blank" href={props.file} rel="noreferrer">
            <img style={{ width: '100px' }} src={props.file} alt="uploaded" />
          </a>
          {!props.disabled && (
            <div onClick={clickRemove} className="required" style={{ cursor: 'pointer', textAlign: 'center', marginTop: '5px' }}>
              remover
            </div>
          )}
          {props.error && (
            <div
              className="error invalid-feedback"
              style={{ display: 'inline', width: '100%', marginLeft: '10px' }}
            >
              {props.error}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

FileUploadS3.defaultProps = {
  onChange: () => { },
  onUpload: () => { },
  beforeUpload: () => { },
  path: '',
  accept: 'media_type',
  titleButton: 'Anexar',
  file: '',
  limitFileSize: 300,
  disabled: false,
};

export default FileUploadS3;